// extracted by mini-css-extract-plugin
export default {"post_detail":"PostDetails_post_detail__pMCLh","tags":"PostDetails_tags__8SRNa","createdby":"PostDetails_createdby__7MTW2"};